import React, { Component } from 'react';
import { isEqual } from 'lodash';

class TenantDropDown extends Component {
    render() {
        const {
            onChange,
            options,
            tenantId
        } = this.props;
        return (
            // <select className="form-select bg-beki" onChange={onChange}>
            //     {options && options.map((list, index) => (
            //         <option
            //             key={index}
            //             defaultValue={list.tenantId}
            //             selected={list.tenantId == tenantId}
            //         >
            //             {(list.accountType===0)?`${list.parentTenantName}`:`${list.tenantName} (${list.parentTenantName})`}
            //         </option>
            //     ))
            //     }
            // </select>
            <select className="form-select bg-beki pr-2" onChange={onChange}>
                <option value="">--Select--</option>
                {options && options.map((list, index) => (
                    <option
                        key={index}
                        defaultValue={list.tenantId}
                        selected={list.tenantId == tenantId}
                        value={list.tenantId}
                    >
                        {(list.accountType === 0) ? `${list.parentTenantName}` : `${list.tenantName} (${list.parentTenantName})`}
                    </option>
                ))}
            </select>
        );
    }
}

export default TenantDropDown;